<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Fortress Europe</h1>
<p class="sub_heading">From Stone to Steel Fortifications, 1850–1945</p>
<p class="author1">J.E. Kaufmann and H.W. Kaufmann</p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?3716f20b